import usePagination from '@/hooks/usePagination/usePagination';
import JobList from '../JobList/JobList';
import JobListPagination from '../JobListPagination/JobListPagination';
import Spacer from '../Spacer/Spacer';
import type { JobListWithPaginationProps } from './JobListWithPagination.interfaces';

const INITIAL_PAGE = 1;

const JobListWithPagination = ({
  jobs,
  isFavorite,
  toggleFavorite,
  hasItemPadding,
  itemsPerPage = 4,
}: JobListWithPaginationProps) => {
  const {
    currentData: currentJobs,
    prev,
    next,
    canGoPrev,
    canGoNext,
    currentPage,
    jumpToPage,
    maxPage,
  } = usePagination(jobs, { itemsPerPage, initialPage: INITIAL_PAGE });

  return (
    <div>
      <JobList
        isFavorite={isFavorite}
        toggleFavorite={toggleFavorite}
        jobs={currentJobs}
        styleVariant="borderBetween"
        hasItemPadding={hasItemPadding}
      />
      <Spacer defaultSize={2} />
      <JobListPagination
        currentPage={currentPage}
        canGoNext={canGoNext}
        canGoPrev={canGoPrev}
        jumpToPage={jumpToPage}
        next={next}
        prev={prev}
        maxPage={maxPage}
      />
    </div>
  );
};

export default JobListWithPagination;
